"use es6";

import { isMotionValue } from "../utils/is-motion-value";
function isWillChangeMotionValue(value) {
  return Boolean(isMotionValue(value) && value.add);
}
export { isWillChangeMotionValue };